import apiClient from "../lib/apiClient";

//=============Getstudent Attandance Report=================

export const getStudentAttendanceReport =
  async (userId) => {

    try {

      const response = await apiClient.get(
        `/LiveClasses/GetStudentAttendanceReport?userId=${userId}`
      );

      return response.data;

    } catch (error) {

      console.log(
        "Attendance API Error",
        error
      );

      throw error;

    }

  };